import React, { useCallback } from 'react'
import { Upload, Select } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { BATCH_RECORD_TYPE } from '@utils/CONST'
import TableUploadView from '../../TableUploadView.jsx'
import styles from '../../../index.module.scss'

export const SimRecolorInputCell = ({
    record,
    setDataSource,
    listSkuByProject,
    projectId,
    uploading,
    beforeUpload,
    handleDrop,
}) => {
    if (record?.inputCloth) {
        return (
            <TableUploadView
                url={record?.inputCloth}
                setDataSource={setDataSource}
                item={record}
                type={BATCH_RECORD_TYPE.SIM_RECOLOR_INPUT}
                width={128}
                listSkuByProject={listSkuByProject}
                projectId={projectId}
                onReupload={(file, fileList, item, type) => beforeUpload(file, fileList, item, type)}
            />
        )
    }

    return (
        <div className={styles.coordinationWrap}>
            <Upload.Dragger
                accept='image/jpeg,image/png,image/webp,image/avif'
                listType="picture-card"
                showUploadList={false}
                className={`${styles.MatchClothesUpload} ${record?.error ? styles.SelectModelBtnError : ''}`}
                beforeUpload={(file, fileList) => beforeUpload(file, fileList, record, BATCH_RECORD_TYPE.SIM_RECOLOR_INPUT)}
                onDrop={(e) => handleDrop(e, BATCH_RECORD_TYPE.SIM_RECOLOR_INPUT)}
                disabled={(record?.matchLoading && uploading)}
                multiple={false}
            >
                <div className={styles.SelectModelBtnContent}>
                    {record?.matchLoading ? <LoadingOutlined /> : <PlusOutlined />}
                    <p>上传衣服平铺图</p>
                </div>
            </Upload.Dragger>
        </div>
    )
}

export const SimRecolorClothTypeCell = ({ record, showSelectionColumn, setDataSource }) => {
    const clothType = record?.clothType

    const handleChange = useCallback((value) => {
        setDataSource(prev =>
            prev.map(it => {
                if (it.skuId !== record.skuId) return it
                return { ...it, clothType: value }
            })
        )
    }, [record?.skuId, setDataSource])

    if (!record?.inputCloth) {
        return (
            <Select
                style={{ width: 140 }}
                placeholder='服装类型'
                disabled={true}
            />
        )
    }

    if (clothType === '') {
        return (
            <Select
                suffixIcon={<LoadingOutlined />}
                style={{ width: 140 }}
                placeholder='自动识别服装类型'
                disabled={true}
            />
        )
    }

    return (
        <Select
            style={{ width: 120 }}
            disabled={showSelectionColumn}
            onChange={handleChange}
            placeholder="服装类型"
            value={clothType}
            options={[
                { value: 0, label: '上装' },
                { value: 1, label: '下装' },
                { value: 3, label: '连体装' }
            ]}
        />
    )
}

export const SimRecolorMatchCell = ({
    record,
    setDataSource,
    listSkuByProject,
    projectId,
    uploading,
    beforeUpload,
    handleDrop,
}) => {
    const clothType = record?.clothType

    if (record?.matchCloth) {
        return (
            <TableUploadView
                url={record?.matchCloth}
                setDataSource={setDataSource}
                item={record}
                type={BATCH_RECORD_TYPE.SIM_RECOLOR_MATCH}
                width={128}
                listSkuByProject={listSkuByProject}
                projectId={projectId}
                onReupload={(file, fileList, item, type) => beforeUpload(file, fileList, item, type)}
            />
        )
    }

    return (
        <div className={styles.coordinationWrap}>
            <Upload.Dragger
                accept='image/jpeg,image/png,image/webp,image/avif'
                listType="picture-card"
                showUploadList={false}
                className={styles.MatchClothesUpload}
                beforeUpload={(file, fileList) => beforeUpload(file, fileList, record, BATCH_RECORD_TYPE.SIM_RECOLOR_MATCH)}
                onDrop={(e) => handleDrop(e, BATCH_RECORD_TYPE.SIM_RECOLOR_MATCH)}
                disabled={(record?.matchLoading && uploading) || clothType === 3}
                multiple={false}
            >
                <div className={styles.SelectModelBtnContent}>
                    {record?.matchLoading ? <LoadingOutlined /> : <PlusOutlined />}
                    <p>上传搭配图</p>
                </div>
            </Upload.Dragger>
        </div>
    )
}